<template>
  <div v-if="value && value.Translations">
    <v-container no-gutters pa-0>
      <v-row no-gutters>
        <v-col>
          <v-menu
            ref="popup"
            bottom
            origin="center center"
            transition="scale-transition"
            v-model="showTrans"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{}">
              <v-textarea
                v-if="
                  value.Translations.filter(
                    (o) => o.LanguageCode === language.language
                  ).length === 0
                "
                v-model="value[field]"
                :label="label"
                :rules="rules"
                :disabled="disabled"
              ></v-textarea>
              <v-textarea
                v-else
                v-model="
                  value.Translations.filter(
                    (o) => o.LanguageCode === language.language
                  )[0][field]
                "
                :label="label"
                :rules="rules"
                :disabled="disabled"
                @input="onLanguageInput(language.language)"
              ></v-textarea>
            </template>
            <v-list>
              <v-list-item
                v-for="(lang, index) of languages.filter(
                  (l) => l.language !== language.language
                )"
                :key="index"
              >
                <v-textarea
                  v-if="showTrans"
                  v-on:keydown.tab="
                    $refs.button.$el.focus();
                    showTrans = false;
                  "
                  ref="translations"
                  v-model="
                    value.Translations.filter(
                      (o) => o.LanguageCode === lang.language
                    )[0][field]
                  "
                  :label="$t('components.transtextbox.' + label, lang.language)"
                  :rules="rules"
                  :disabled="disabled"
                  @input="onLanguageInput(lang.language)"
                ></v-textarea>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>

        <v-col
          cols="auto"
          v-if="languages.length > 1"
          style="margin-top:20px;margin-left:3px"
        >
          <v-btn
            ref="button"
            @click="openAndFocus()"
            depressed
            small
            color="success"
            :disabled="disabled"
          >
            <v-icon>language</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { translate } from "../trans";
export default {
  name: "trans-textarea",
  props: ["value", "rules", "label", "disabled", "field", "dialog"],
  mounted() {
    this.$nextTick(() => {
      this.createTranslations();
      this.$forceUpdate()
    });
  },
  data() {
    return {
      showTrans: false,
      emptyTranslations: [],
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    currentLanguageIndex() {
      // console.log(this.languages, this.value);
      if (this.languages && this.languages.length > 1) {
        const langs = this.languages.filter(
          (o) => o.language === this.language.language
        );
        // console.log(langs);
        if (langs.length > 0) return this.languages.indexOf(langs[0]);
      }
      return -1;
    },
    currentTranslationsIndex() {
      // console.log(this.languages, this.value);
      // console.log(this.value.Translations.filter(o => o.LanguageCode === "fr"));
      if (this.value.Translations && this.value.Translations.length > 1) {
        const langs = this.value.Translations.filter(
          (o) => o.LanguageCode === this.language.language
        );
        // console.log(langs);
        if (langs.length > 0) return this.value.Translations.indexOf(langs[0]);
      }
      // console.log(this.value.Translations.filter(o => o.LanguageCode === "fr"));
      return -1;
    },
  },
  watch: {
    value: {
      handler() {
        this.$nextTick(() => {
          this.createTranslations();
        });
        // console.log(this.label);
      },
    },
    dialog: {
      handler(v) {
        if (!v) this.showTrans = false;
      },
    },
  },
  methods: {
    createTranslations() {
      console.log(this.languages, this.value);
      // console.log(this.languages);
      if (this.createdTranslations) {
        return;
      }
      this.createdTranslations = true;
      if (!this.value.Translations) this.value.Translations = [];
      for (const lang of this.languages) {
        // console.log(lang);
        
        if (
          this.value.Translations.filter(
            (o) => o.LanguageCode === lang.language
          ).length === 0
        ) {
          // console.log(lang);
          this.value.Translations.push({
            LanguageCode: lang.language,
            [this.field]: this.value[this.field],
          });
        }
      }
      this.emptyTranslations = [];
      const translations = this.value.Translations.filter(
        (t) => t[this.field] !== "" && t[this.field] !== null
      );
      for (var trans of this.value.Translations) {
        if (
          trans[this.field] === "" ||
          trans[this.field] === null ||
          trans[this.field] === undefined
        ) {
          this.emptyTranslations.push(trans.LanguageCode);
          trans[this.field] = this.value[this.field];
          if (!trans[this.field] && translations.length > 0) {
            trans[this.field] = translations[0][this.field];
          }
        }
      }
    },
    onLanguageInput(lang) {
      this.emptyTranslations = this.emptyTranslations.filter((a) => a !== lang);
      const item = this.value.Translations.filter(
        (t) => t.LanguageCode === lang
      )[0];
      for (var l of this.emptyTranslations) {
        this.value.Translations.filter((t) => t.LanguageCode === l)[0][
          this.field
        ] = item[this.field];
      }
    },
    trans(item) {
      return translate(item, this.language.language);
    },
    openAndFocus() {
      this.showTrans = !this.showTrans;
      setTimeout(() => {
        this.$refs.translations[0].focus();
      }, 100);
    },
  },
};
</script>
